import { Modal } from '@musinsa/mwms-ds'
import dayjs from 'dayjs'
import { Utils } from '@/utils/Utils'
import { DATE_FORMAT } from '@/utils/consts'
import { useGetBasePriceTimeline } from '@/services/settlement/settlementPricing/useSettlementPricingQueries'

interface Props {
  masterId: number | null
  onClose: () => void
}

const won = (v?: number | null) => (v || v === 0 ? `${Utils.getCommaNum(v)}원` : '-')
const num = (v?: number | null) => (v || v === 0 ? Utils.getCommaNum(v) : '-')
const date = (v?: string | null) => (v ? dayjs(v).format(DATE_FORMAT.date) : '-')

// 상단 정보 행: label(130·회색) + value(bold)
function InfoRow({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', fontSize: 14, lineHeight: '20px' }}>
      <span style={{ width: 130, flexShrink: 0, color: '#6b7280' }}>{label}</span>
      <span style={{ color: '#1f2937', fontWeight: 600 }}>{value}</span>
    </div>
  )
}

const th: React.CSSProperties = { padding: '10px 14px', fontSize: 13, fontWeight: 600, color: '#6b7280', textAlign: 'left' }
const td: React.CSSProperties = { padding: '12px 14px', fontSize: 14, color: '#1f2937' }

export function BasePriceHistoryModal({ masterId, onClose }: Props) {
  const { data } = useGetBasePriceTimeline(masterId)
  if (masterId === null) return null

  const currentText = data?.currentPrice != null ? `${won(data.currentPrice)} (적용 ${date(data.currentApplyStartDate)}~)` : '-'
  const rows = data?.rows ?? []

  return (
    <Modal
      open={masterId !== null}
      customWidth={520}
      title="단가 변경 이력"
      buttons={[{ kind: 'primary', content: '닫기', onClick: onClose }]}
      onClose={onClose}
    >
      <div style={{ width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 9, paddingBottom: 6 }}>
          <InfoRow label="국가" value={data?.country?.name ?? '-'} />
          <InfoRow label="서비스 항목" value={data?.serviceType?.name ?? '-'} />
          <InfoRow label="단위" value={data?.chargeBaseType?.code === 'INVOICE' ? '송장' : (data?.unitType?.name ?? '-')} />
          <InfoRow label="주문유형" value={data?.orderType?.name ?? '-'} />
          <InfoRow label="현재 단가" value={currentText} />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 6, margin: '16px 0 8px', fontSize: 14, fontWeight: 700 }}>
          <span style={{ color: '#1f2937' }}>전체</span>
          <span style={{ color: '#245EFF' }}>{rows.length}</span>
        </div>

        <div style={{ border: '1px solid #e6e6e6', borderRadius: 8, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fc' }}>
                <th style={{ ...th, textAlign: 'right', width: '34%' }}>단가 (원)</th>
                <th style={th}>시작일</th>
                <th style={th}>종료일</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td style={{ ...td, textAlign: 'center', color: '#9ca3af' }} colSpan={3}>
                    변경 이력이 없습니다.
                  </td>
                </tr>
              ) : (
                rows.map((r) => (
                  <tr key={`${r.startDate}-${r.endDate}`} style={{ borderTop: '1px solid #f0f0f0' }}>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 600 }}>{num(r.unitPrice)}</td>
                    <td style={td}>{date(r.startDate)}</td>
                    <td style={td}>{date(r.endDate)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  )
}
